import { createSlice } from '@reduxjs/toolkit';
import { IUser } from '../interfaces/User.interfaces';

type userProfileStateType = {
  userProfile: IUser | undefined;
};

const initialState: userProfileStateType = {
  userProfile: undefined,
};

export const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    resetUserProfile: (state) => {
      state.userProfile = undefined;
    },

    setUserProfile: (state, action) => {
      state.userProfile = action.payload;
    },
  },
});
